import { Model } from '@lernetz/ts-lib';

export abstract class Slide extends Model {

    public unlocked: boolean;
    public hasInput: boolean;
    public evaluated: boolean;

    protected constructor( dto: object ) {
        super( {
            unlocked: false,
            hasInput: false,
            evaluated: false,
            ...dto,
        } );
    }
}
